import enquire from 'enquire.js/dist/enquire.min';
/**
 * main nav
 */

const siteHeaderBranding = document.querySelector('.site-header__branding');

/* SLIDE UP */
let VJSslideUp = (target, duration=500) => {
    //console.log('slide up is called');

    target.style.transitionProperty = 'height, padding, margin';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout( () => {
          target.style.display = 'none';
          target.style.removeProperty('height');
          target.style.removeProperty('padding-top');
          target.style.removeProperty('padding-bottom');
          target.style.removeProperty('margin-top');
          target.style.removeProperty('margin-bottom');
          target.style.removeProperty('overflow');
          target.style.removeProperty('transition-duration');
          target.style.removeProperty('transition-property');
          //alert('!');
          document.body.classList.remove('js-nav--expanded');
          siteHeaderBranding.classList.remove('js-hide');
    }, duration);
}

/* SLIDE DOWN */
let VJSslideDown = (target, duration=500) => {

    // console.log('slide down is called');

    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;
    if (display === 'none') display = 'block';
    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = 'height, padding, margin';
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    window.setTimeout( () => {
      target.style.removeProperty('height');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
    }, duration);
}

/* TOOGLE */
var VJSslideToggle = (target, duration = 500) => {
    if (window.getComputedStyle(target).display === 'none') {
      return VJSslideDown(target, duration);
    } else {
      return VJSslideUp(target, duration);
    }
}

// run js depends on the screen size
enquire.register('screen and (max-width: 992px)', {
    match: function () {
        // show mobile menu after clicking on the hamburger button
        document.querySelector('.nav__container').style.display = 'none'; // $('.nav__container').css('display', 'none');
        document.querySelector('.nav__toggler-btn').addEventListener('click', () => { // $('.nav__toggler-btn').click(function () {
            // console.log('event listener click on nav toggler button');
            // animate appearance of the menu
            const body = document.body;
            // console.log(body.classList);
            const navTogglerBtn = document.querySelector('.nav__toggler-btn');
            
            const navContainer = document.querySelector('.nav__container');
            if (!body.classList.contains('js-nav--expanded')) { // if (!$('body').hasClass('js-nav--expanded')) {
                // console.log('if body has class js-nav--expanded');
                navTogglerBtn.classList.add('is-active');//$('.nav__toggler-btn').addClass('is-active');
                VJSslideDown(navContainer);// $('.nav__container').slideDown();
                body.classList.add('js-nav--expanded'); //$('body').addClass('js-nav--expanded');
                siteHeaderBranding.classList.add('js-hide'); // $('.site-header__branding').addClass('js-hide');
            } else {
                // console.log('else');
                navTogglerBtn.classList.remove('is-active');// $('.nav__toggler-btn').removeClass('is-active');
                VJSslideUp(navContainer, 1000);
                
                 // {  $('.nav__container').slideUp(function () {
                   // $('body').removeClass('js-nav--expanded');
                    //$('.site-header__branding').removeClass('js-hide');
                //});
            }
        });

        // TODO: Currently filter expand is not working. Already the case before js vanilla rewrite.
        // TODO: Move stuff about sections to section js, only js for nav here.

        if (document.querySelector('section.s-products-with-filter')) {
            // if ($('section.s-products-with-filter').length !== 0) {
            const filtersView1 = document.querySelector('#filters-view');
            const subtitleAndArrow1 = document.querySelector('.subtitle-and-arrow');
            filtersView1.classList.remove('js-expanded');
            subtitleAndArrow1.classList.remove('js-expanded');
            document.querySelector('.js-filter-expand').addEventListener('click', () => {  // $('.js-filter-expand').click(function () {
                
                // $('.filters-view, .subtitle-and-arrow').toggleClass('js-expanded');

                
                filtersView1.classList.toggle('js-expanded');
                subtitleAndArrow1.classList.toggle('js-expanded'); // $('.filters-view, .subtitle-and-arrow').addClass('js-expanded');
            });
        }
        if (document.querySelector('section.s-jobs-overview')) {
            document.querySelector('.js-filter-expand').addEventListener('click', () => {                
                const subtitleAndArrow = document.querySelector('.filters-view, .subtitle-and-arrow');                
                subtitleAndArrow.classList.toggle('js-expanded');
            });
        }

        const submenuDropdown = document.querySelectorAll('.nav__menu-item--has-children, .nav__menu-item--has-mega-menu');

        if (submenuDropdown) {
            for (let i = 0; i < submenuDropdown.length; i++) {
                submenuDropdown[i].addEventListener('click', function () {
                    submenuDropdown[i].classList.toggle('open');
                    // $('.nav__sub-menu').slideToggle(); //nicer effect but interfering with desktop
                });
            }
        }
    },
    unmatch: function () {
        document.querySelector('.nav__container').style.display = 'flex'; // $('.nav__container').css('display', 'flex');
        document.body.classList.remove('js-nav--expanded'); // $('body').removeClass('js-nav--expanded');
        document.querySelector('.nav__container').classList.remove('js-show'); // $('.nav__container').removeClass('js-show');
        document.querySelector('.nav__toggler-btn').classList.remove('is-active'); // $('.nav__toggler-btn').removeClass('is-active');
        document.querySelector('.site-header__branding').classList.remove('js-hide'); // $('.site-header__branding').removeClass('js-hide');
        // TODO: define constants once at top of match/unmatch
        // TODO: Fix after resizing back to mobile, menu opens and immediately closes again on click. Already there before js rewrite. I believe addEventListener above needs to be named, so we can remove it here as well.
        //document.querySelector('.nav__toggler-btn').removeEventListener('click'); // $('.nav__toggler-btn').off('click'); // Unbinding the click event on the toggler button.
        if (document.querySelector('section.s-products-with-filter')) { // if ($('section.s-products-with-filter').length !== 0) {
            const filtersView2 = document.querySelector('#filters-view');
            const subtitleAndArrow2 = document.querySelector('.subtitle-and-arrow');
            filtersView2.classList.add('js-expanded');
            subtitleAndArrow2.classList.add('js-expanded'); // $('.filters-view, .subtitle-and-arrow').addClass('js-expanded');
        }
    },
});

// Menu: Add class to body when user scroll down the page
// Todo: replace with intersection observer + polyfill in the future DONE, see below
// function fixedMenu() {
//     // console.log('inside fixedMenu');
//     if ($(window).scrollTop() > 0) {
//         console.log('window scroltop bigger than 0');
//         $('body').addClass('js-site-header--fixed');
//     } else {
//         console.log('window scroltop not bigger than 0');
//         $('body').removeClass('js-site-header--fixed');
//     }
// }
// fixedMenu();
// $(window).on('load resize scroll', function () {
//     fixedMenu();
// });

// Menu: Add class to body when user scroll down the page
if (
    'IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype
  ) {
  let observer = new IntersectionObserver(entries => {
    if (entries[0].boundingClientRect.y < 0) {
        document.body.classList.add('js-site-header--fixed');
    } else {
        document.body.classList.remove('js-site-header--fixed');
    }
  });
  observer.observe(document.querySelector('#top-of-site-pixel-anchor'));
}

// Menu: search bar (DEPRECATED: jQuery, see vanilla js solution below)
// $('.c-search-bar__toggle-link, .c-search-bar__close-link').click(function (e) {
//     e.preventDefault();
//     $('.c-search-bar').slideToggle();
//     $('body').toggleClass('js-show-search-bar');
//     $('.c-search-bar').css({
//         display: 'flex',
//     });
//     $('.c-search-bar__form-input').focus();
// });

// Menu: search bar
const searchBar = document.querySelector('.c-search-bar');
if (searchBar) {
    const searchToggleLink = document.querySelector('.c-search-bar__toggle-link');
    const searchClose = document.querySelector('.c-search-bar__close-link');
    if (searchToggleLink) {
        searchToggleLink.addEventListener('click', showSearch);
    }
    if (searchClose) {
        searchClose.addEventListener('click', hideSearch);
    }
}

function showSearch(e) {
    e.preventDefault();
    VJSslideToggle(searchBar);
    document.body.classList.toggle('js-show-search-bar');
    searchBar.style.display = 'flex';
    document.querySelector('.c-search-bar__form-input').focus();
}

function hideSearch(e) {
    e.preventDefault();
    VJSslideUp(searchBar);
    document.body.classList.remove('js-show-search-bar');
    // searchBar.style.display = 'none';
}

// search bar - hide when click outside of nav and search-bar (old)
// $(document).mouseup(function (e) {
//     var container = $('.c-search-bar, .nav');
//     // hide the search bar if an area outside the container variable is clicked
//     if (!container.is(e.target) && container.has(e.target).length === 0) {
//         $('body').removeClass('js-show-search-bar');
//         $('.c-search-bar').slideUp();
//     }
// });

/* search bar - hide when click outside of nav and search-bar */
// TODO: Bug on mobile, when clicking menu search, then clicking outside of it. Now logo visible suddenly and menu items all jump to the right.
var siteHeader = document.querySelector('.site-header');
if (document.querySelector('.c-search-bar')) {
    document.addEventListener('click', function(event) {
        var isClickInside = siteHeader.contains(event.target);
        if (!isClickInside) {
            // You clicked outside of specifiedElement
            VJSslideUp(document.querySelector('.c-search-bar'));
        }
    });
}

/* If mobile menu item with submenu is clicked, open submenu. */
// const submenuDropdown = document.querySelectorAll('.nav__menu-item--has-children, .nav__menu-item--has-mega-menu');

// if (submenuDropdown) {
//     for (let i = 0; i < submenuDropdown.length; i++) {
//         submenuDropdown[i].addEventListener('click', function () {
//             submenuDropdown[i].classList.toggle('open');
//             // $('.nav__sub-menu').slideToggle(); //nicer effect but interfering with desktop
//         });
//     }
// }

/* If mobile menu language selector is clicked, open language dropdown menu. */
const languageSwitcherCurrentLanguage = document.querySelector('.c-language-switcher__current-language');
const languageSwitcherContainer = document.querySelector('.c-language-switcher');

if (languageSwitcherCurrentLanguage) {
    languageSwitcherCurrentLanguage.addEventListener('click', function () {
        languageSwitcherContainer.classList.toggle('open');
    });
}

/* If mobile menu menu-account selector is clicked, open menu account dropdown menu. */
const menuAccountCurrentUser = document.querySelector('.c-menu-account__current-user');
const menuAccountContainer = document.querySelector('.c-menu-account');

if (menuAccountCurrentUser) {
    menuAccountCurrentUser.addEventListener('click', function () {
        menuAccountContainer.classList.toggle('open');
    });
}



// WEBPACK FOOTER //
// ./scripts/routes/other/nav.js